// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-highlight:hover p[data-v-38f68e0d]{color:#141c20}.btn-highlight[data-v-38f68e0d]:hover .sb-icon .icon.mask{background-color:#141c20!important}.lighter[data-v-38f68e0d]{font-size:14px;font-weight:500;color:#7c8b91}[data-v-38f68e0d] .list .list-item{height:34px;margin:0 0 8px;padding:9px 5px 9px 12px;border-radius:10px;-webkit-box-shadow:0 1px 3px 0 rgba(48,54,70,.1);box-shadow:0 1px 3px 0 rgba(48,54,70,.1);border:1px solid #cfd8dc;background-color:#fff}", ""]);
// Exports
module.exports = exports;
